import React from 'react'
import ImportClass from '../../client/ImportClass'
import V3ProfileRouteShell from '../profile/V3ProfileRouteShell'

export default function V3ImportClassPage() {
  return (
    <V3ProfileRouteShell>
      <ImportClass />
    </V3ProfileRouteShell>
  )
}

